import api from "../../api/api";

const state = {
    cart: {},
    scanned_cart: [],
    cart_type: "branch",
    scan_mode: false,
    scan_to_paste:false,
    oe_mode: false,
    in_stock_only: true,
    active_company: 0,
    active_company_low_stock:0,
    count_order_mode: false,
    stock: {},
    order: {},
    payment_processor: {},
    invoice: {},
    line_items: [],
    stocks: {},
    similar_stock: [],
    source_of_truth: [],
    orders_transactions: [],
    orders_receiving: [],
    pos_transaction_by_id: [],
    orders_transaction_by_id: [],
    searched_orders_transactions: [],
    all: {
        incoming_orders: [],
        outgoing_orders: [],
        branch_transfer_history: [],
    },
    // Stock Reservations
    stock_reservations: [],
    inventory_with_reservations: {},
};

const mutations = {
    UPDATE_INCOMING_ORDERS(state, payload) {
        state.all.incoming_orders = payload;
    },
    GET_SEARCHED_ORDERS_TRANSACTIONS(state, payload) {
        state.searched_orders_transactions = payload;
    },
    SET_ORDERS_TRANSACTIONS(state, payload) {
        state.orders_transactions = payload;
    },
        SET_ORDERS_RECEIVING(state, payload) {
        state.orders_receiving = payload;
    },

    GET_POS_TRANSACTION_BY_ID(state, payload) {
        state.pos_transaction_by_id = payload;
    },

    GET_ORDERS_TRANSACTION_BY_ID(state, payload) {
        state.orders_transaction_by_id = payload;
    },

    // Stock Reservations mutations
    SET_STOCK_RESERVATIONS(state, payload) {
        state.stock_reservations = payload;
    },
    ADD_STOCK_RESERVATION(state, payload) {
        state.stock_reservations.push(payload);
    },
    UPDATE_STOCK_RESERVATION(state, payload) {
        const index = state.stock_reservations.findIndex(r => r.id === payload.id);
        if (index !== -1) {
            state.stock_reservations.splice(index, 1, payload);
        }
    },
    REMOVE_STOCK_RESERVATION(state, reservationId) {
        state.stock_reservations = state.stock_reservations.filter(r => r.id !== reservationId);
    },
    SET_INVENTORY_WITH_RESERVATIONS(state, payload) {
        state.inventory_with_reservations = payload;
    },
    UPDATE_INVENTORY_RESERVED_STOCK(state, { inventoryId, branchId, reservedQuantity }) {
        const key = `${inventoryId}_${branchId}`;
        if (!state.inventory_with_reservations[key]) {
            state.inventory_with_reservations[key] = { reservedQuantity: 0 };
        }
        state.inventory_with_reservations[key].reservedQuantity = reservedQuantity;
    },

    update_cart(state, payload) {
        state.cart = payload;
    },
    update_stock(state, payload) {
        state.stock = payload;
    },
    update_order(state, payload) {
        state.order = payload;
    },
    update_payment_processor(state, payload) {
        state.payment_processor = payload;
    },
    update_invoice(state, payload) {
        state.invoice = payload;
    },
    update_line_items(state, payload) {
        state.line_items = payload;
    },
    reset_cart(state) {
        state.line_items = [];
        state.source_of_truth = [];
    },
    reset_scan_count(state) {
        state.scanned_cart = [];
    },
    SCAN_TO_CART(state, payload) {
        //update to use lodash instead
        let found = false;
        if (typeof state.scanned_cart === "string") {
            state.scanned_cart = [];
        }
        let scan_reset = state.scanned_cart;
        state.scanned_cart = false;
        state.scanned_cart = scan_reset;
        state.scanned_cart.forEach((e) => {
            if (e.id == payload.id) {
                let newamount = parseInt(e.amount) + 1;
                e.amount = newamount;
                e.checkCount = newamount;
                found = true;
            }
        });
        if (found == false) {
            payload.amount = 1;
            payload.checkCount = 0;
            state.scanned_cart.push(payload);
        }
    },
    ADD_LINE_ITEM(state, payload) {
        //update to use lodash instead
        let found = false;
        if (typeof state.line_items === "string") {
            state.line_items = [];
        }
        state.line_items.forEach((e) => {
            //console.log(e);
            if (e.id == payload.id) {
                let newamount = parseInt(e.amount) + 1;
                e.amount = newamount;
                found = true;
            }
        });
        //console.log(found);
        if (found == false) {
            state.line_items.push(payload);
            state.source_of_truth.push(payload);
        }
    },
    update_lineitem_stock(state, payload) {
        state.line_items = Array.isArray(payload) ? payload : [];
    },
    remove_line_items(state, payload) {
        var index = state.line_items.indexOf(payload);
        if (index > -1) {
            state.line_items.splice(index, 1);
        }
        
        var truth_index = state.source_of_truth.indexOf(payload);
        if (truth_index > -1) {
            state.source_of_truth.splice(index, 1);
        }
    },
    clear_scan_count(state) {
        state.scanned_cart = [];
    },
    remove_scanned_item(state, payload) {
        var index = state.scanned_cart.indexOf(payload);
        if (index > -1) {
            state.scanned_cart.splice(index, 1);
        }
    },
    cart_type(state, payload) {
        state.cart_type = payload;
    },
    scan_mode(state, payload) {
        state.scan_mode = payload;
    },
    oe_mode(state, payload) {
        state.oe_mode = payload;
    },
    scan_to_paste(state, payload) {
        state.scan_to_paste = payload;
    },
    in_stock_only(state, payload) {
        state.in_stock_only = payload;
    },
    active_company(state, payload) {
        state.active_company = payload;
    },
    active_company_low_stock(state, payload) {
        state.active_company_low_stock = payload;
    },
    count_order_mode(state, payload) {
        state.count_order_mode = payload;
    },
    allStockHistory(state, payload){
        state.stocks = payload;
    },
    fetch_user_branch_stock_history(state, payload){
        state.stocks = payload;
    },
    fetch_by_inventory_and_branch(state, payload){
        state.similar_stock = payload;
    },
};

const actions = {

    async fetchStockReservations(context, { orderId = null, branchId = null } = {}) {
        try {
            let url = "/api/stock-reservations";
            const params = new URLSearchParams();
                
            if (orderId) params.append('order_id', orderId);
            if (branchId) params.append('branch_id', branchId);
            
            if (params.toString()) {
                url += `?${params.toString()}`;
            }
            
            const res = await api.instance.get(url);
            
            // Handle the response structure
            let payload = res.data;
            if (payload && payload.data) {
                payload = payload.data;
            }
            
            // Ensure it's an array
            if (!Array.isArray(payload)) {
                payload = [];
            }
            
            context.commit("SET_STOCK_RESERVATIONS", payload);
            return { data: payload };
        } catch (error) {
            console.error("Error fetching stock reservations:", error);
            context.commit("SET_STOCK_RESERVATIONS", []);
            return { data: [] };
        }
    },

    async createStockReservation(context, reservationData) {
        try {
            const res = await api.instance.post("/api/stock-reservations", reservationData);
            if (res.data) {
                context.commit("ADD_STOCK_RESERVATION", res.data);
                // Update inventory reserved stock count
                context.commit("UPDATE_INVENTORY_RESERVED_STOCK", {
                    inventoryId: res.data.inventory_id,
                    branchId: res.data.source_branch_id,
                    reservedQuantity: res.data.reserved_quantity
                });
            }
            return res.data;
        } catch (error) {
            console.error("Error creating stock reservation:", error);
            throw error;
        }
    },

    async releaseOrderReservations(context, { orderId, invoiceNumber, reason = null }) {
        try {
            const res = await api.instance.post(`/api/stock-reservations/release-order`, {
                order_id: orderId,
                invoice_number: invoiceNumber,
                reason
            });
            return res.data;
        } catch (error) {
            console.error("Error releasing order reservations:", error);
            throw error;
        }
    },

    async fulfillStockReservation(context, { order_id }) {
        try {
        const res = await api.instance.post('/api/stock-reservations/fulfill-order', {
            order_id
        });
        
        if (res.data) {
            context.commit("UPDATE_STOCK_RESERVATION", res.data);
        }

        return res.data;
        } catch (error) {
        console.error("Error fulfilling stock reservation:", error);
        throw error;
        }
    },


    // extend reservations for order
    async extendStockReservation(context, { orderId, invoiceNumber, hours = 24 }) {
        try {
            const res = await api.instance.post(`/api/stock-reservations/extend-by-order`, {
                order_id: orderId,
                invoice_number: invoiceNumber,
                hours
            });

            if (res.data && Array.isArray(res.data.reservations)) {
                res.data.reservations.forEach(reservation => {
                    context.commit("UPDATE_STOCK_RESERVATION", reservation);
                });
            }

            return res.data;
        } catch (error) {
            console.error("Error extending stock reservations for order:", error);
            throw error;
        }
    },


    async cleanupExpiredReservations(context) {
        try {
            const res = await api.instance.post("/api/stock-reservations/cleanup-expired");
            // Refresh reservations after cleanup
            await context.dispatch("fetchStockReservations");
            return res.data;
        } catch (error) {
            console.error("Error cleaning up expired reservations:", error);
            throw error;
        }
    },

    async getInventoryWithReservations(context, { branchId }) {
        try {
            const res = await api.instance.get(`/api/inventory/with-reservations?branch_id=${branchId}`);
            const payload = res.data || {};
            context.commit("SET_INVENTORY_WITH_RESERVATIONS", payload);
            return payload;
        } catch (error) {
            console.error("Error fetching inventory with reservations:", error);
            return {};
        }
    },

    async checkStockAvailability(context, { inventoryId, branchId, quantity }) {
        try {
            const res = await api.instance.post("/api/stock/check-availability", {
                inventory_id: inventoryId,
                branch_id: branchId,
                quantity: quantity
            });
            return res.data;
        } catch (error) {
            console.error("Error checking stock availability:", error);
            return { available: false, message: "Error checking availability" };
        }
    },
    
         async verifyStockLevelsWithReservations(context) {
                let payload = {};
                let active_company = context.rootState.Pos.active_company?.id;
                await api.instance
                    .post("/api/stock/verifyStockLevelsWithReservations", {
                        line_items: context.state.line_items,
                        branch_id: active_company
                    })
                    .then((res) => {
                        if (!res.data || res.data.length == 0) {
                            payload = false;
                        } else {
                            payload = res.data;
                        }
                        context.commit("update_lineitem_stock", payload);
                    });
            },
    
        // order creation with stock reservations
        async createOrderWithReservations(context, payload) {
            try {
                // First, check stock availability for all items
                for (const item of payload.cart) {
                    const availability = await context.dispatch("checkStockAvailability", {
                        inventoryId: item.id,
                        branchId: payload.request_entity_for.id,
                        quantity: item.amount
                    });
                    
                    if (!availability.available) {
                        throw new Error(`Insufficient stock for ${item.system_number}: ${availability.message}`);
                    }
                }
    
                // Create the order
                const res = await api.instance.post("/api/order", payload);
                
                if (res.data) {
                    context.commit("update_order", res.data);
                    context.commit("update_line_items", "");
                    
                    // Create stock reservations for the order items
                    if (payload.cart) {
                        for (const item of payload.cart) {
                            await context.dispatch("createStockReservation", {
                                quote_id: res.data.id,
                                inventory_id: item.id,
                                source_branch_id: payload.request_entity_for.id,
                                reserved_quantity: item.amount,
                                expires_at: new Date(Date.now() + (3 * 24 * 60 * 60 * 1000)), // 3 days
                                notes: `Reserved for order ${res.data.invoice_number}`
                            });
                        }
                    }
                }
                
                return res.data;
            } catch (error) {
                console.error("Error creating order with reservations:", error);
                throw error;
            }
        },

  async increment_print_count(context, payload) {
    const res = await api.instance.post('/api/order/increment_print_count', { doc_type: payload.doc_type, order_id: payload.order_id });
    return res.data.new_count;
  },
    async request_order_stage_update(context, payload) {
            await api.instance
                .post("/api/order/order_stage_update", payload.package)
                .then((res) => {
                    if (!res.data || res.data.length == 0) {
                        payload.package = { context: false, widgets: false };
                    } else {
                        payload.package = res.data;
                    }
                    context.commit(`${payload.update}`, payload.package);
                });
        },
    async search_orders_transactions(context, keyword) {
        let payload = {};
        await api.instance.get("/api/order/search_orders_transactions/" + keyword).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("GET_SEARCHED_ORDERS_TRANSACTIONS", payload)
        })
    },

    async get_full_transaction_data_by_id(context, order_id) {
        let payload = {};
        await api.instance.get("/api/order/get_full_transaction_data_by_id/" + order_id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("GET_POS_TRANSACTION_BY_ID", payload);
            
        });
    },
        async get_orders_transaction_by_id(context, order_id) {
        let payload = {};
        await api.instance.get("/api/order/get_orders_transaction_data_by_id/" + order_id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("GET_ORDERS_TRANSACTION_BY_ID", payload);
            
        });
    },

    async get_orders_transactions(context, path = "order/get_orders_transactions") {
        let payload = {};
        await api.instance.get("/api/" + path).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("SET_ORDERS_TRANSACTIONS", payload);
        });
    },
        async get_orders_receiving(context, path = "order/get_orders_receiving") {
        let payload = {};
        await api.instance.get("/api/" + path).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("SET_ORDERS_RECEIVING", payload);
        });
    },

    async process_order(contex, payload) {
        await api.instance.post("/api/order/process_order", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async confirm_transfer(contex, payload) {
        await api.instance.post("/api/order/confirm_stock_transfer", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async add_funds_to_wallet(contex, payload) {
        await api.instance.post("/api/order/add_funds_to_wallet", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async issue_refund(contex, payload) {
        
        await api.instance.post("/api/refund/issue_refund", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_packing(contex, payload) {
        await api.instance.post("/api/order/complete_packing", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_receiving(contex, payload) {
        await api.instance.post("/api/order/complete_receiving", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async complete_distribution(contex, payload) {
        await api.instance.post("/api/order/complete_distribution", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
        });
    },
    async fetch_all_pos(context, path = "cart") {
        let payload = {};
        await api.instance.get("/api/" + path).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async fetch_single(context, path = "cart", payload) {
        await api.instance.get("/api/" + path + "/" + payload.id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async create_pos(context, path = "cart", payload) {
        await api.instance.post("/api/" + path + "/", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async update_pos(context, path = "cart", payload) {
        await api.instance.put("/api/" + path + "/" + payload.id, payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async delete_pos(context, path = "cart", payload) {
        await api.instance.delete("/api/" + path + "/" + payload.id).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            context.commit("update_" + path, payload);
        });
    },
    async verifyStockLevels(context) {
        let active_company = context.rootState.Pos.active_company?.id;
        const lineItems = Array.isArray(context.state.line_items) ? context.state.line_items : [];
        if (lineItems.length === 0) {
            context.commit("update_lineitem_stock", []);
            return;
        }
        try {
            const res = await api.instance.post("/api/stock/verifyStockLevels", {
                line_items: lineItems,
                branch_id: active_company,
            });
            if (Array.isArray(res.data)) {
                context.commit("update_lineitem_stock", res.data);
            }
        } catch (error) {
            console.error("Orders verifyStockLevels failed:", error);
        }
    },
    async allStockHistory(context) {
        let payload = {};
        await api.instance
            .get("/api/stock_history/fetch_user_branch_stock_history")
            .then((res) => {
                if (!res.data || res.data.length == 0) {
                    payload = false;
                } else {
                    payload = res.data;
                }
                context.commit("allStockHistory", payload);
            });
    },
    async fetch_user_branch_stock_history(context) {
        let payload = {};
        await api.instance
            .get("/api/stock_history/fetch_user_branch_stock_history")
            .then((res) => {
                if (!res.data || res.data.length == 0) {
                    payload = false;
                } else {
                    payload = res.data;
                }
                context.commit("allStockHistory", payload);
            });
    },
    async search_branch_stock_history(context, payload) {
        const { entity, dates, partNumber, entityType, selectedTypes } = payload;
        
        // Ensure entity is a string/number, not an object
        const entityId = typeof entity === 'object' ? entity?.id : entity;
      
        const typeParams = selectedTypes.length > 0 ? `&types=${selectedTypes.join(',')}` : '';
      
        await api.instance
          .get(`/api/stock_history/search_branch_stock_history?entity=${entityId}&dates=${dates}&partNumber=${partNumber}&entityType=${entityType}${typeParams}`)
          .then((res) => {
            let stockHistoryData;
            if (!res.data || res.data.length === 0) {
              stockHistoryData = false;
            } else {
              stockHistoryData = res.data;
            }
            context.commit("allStockHistory", stockHistoryData);
        });
    },
    async fetch_by_inventory_and_branch(context, payload) {
        try {
          const response = await api.instance.get(`/api/stock_history/fetch_by_inventory_and_branch?inventory_id=${payload.inventory_id}&branch_id=${payload.branch_id}`);
          if (!response.data || response.data.length === 0) {
            return false;
          } else {
            return response.data;
          }
        } catch (error) {
          // Handle error if needed
          console.error(error);
          return null;
        }
    },



    async fetch_import_price_histories(context, payload) {
        try {
          
          const response = await api.instance.get(`/api/fetch_import_price_histories?system_number=${payload.system_number}&branch_id=${payload.branch_id}`);
          if (!response.data || response.data.length === 0) {
            return false;
          } else {
            return response.data;
          }
        } catch (error) {
          // Handle error if needed
          console.error(error);
          return null;
        }
    },









    //the main ones we will delete the above for the new backend pattern
    addLineItem({commit}, payload) {
        commit("ADD_LINE_ITEM", payload);
    },
    scantocartbootup(context, e) {
        context.commit("SCAN_TO_CART", e);
    },
    reset_scan_count(context) {
        context.commit("reset_scan_count");
    },
    async scantocart(context, order) {
        let payload = {};
        await api.instance.get("/api/inventory/system_number/" + order).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data[0];
            }
            context.commit("SCAN_TO_CART", payload);
        });
    },
    clearCart({commit}) {
        commit("reset_cart");
    },
    removeLineItem({commit}, payload) {
        commit("remove_line_items", payload);
    },
    removeScannedItem({commit}, payload) {
        commit("remove_scanned_item", payload);
    },
    async createOrder({commit}, payload) {
        await api.instance.post("/api/order", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            commit("update_order", payload);
            commit("update_line_items", "");
        });
    },
    async logCount({commit}, payload) {
        await api.instance.post("/api/stock/scanToUpdate", payload).then((res) => {
            if (!res.data || res.data.length == 0) {
                payload = false;
            } else {
                payload = res.data;
            }
            commit("clear_scan_count");
        });
    },
    cart_type({commit}, payload) {
        commit("cart_type", payload);
    },
    scan_to_paste({commit}, payload) {
        commit("scan_to_paste", payload);
    },
    scan_mode({commit}, payload) {
        commit("scan_mode", payload);
    },
    oe_mode({commit}, payload) {
        commit("oe_mode", payload);
    },
    in_stock_only({commit}, payload) {
        commit("in_stock_only", payload);
    },
    active_company({commit}, payload) {
        commit("active_company", payload);
    },
    active_company_low_stock({commit},payload){
        commit("active_company_low_stock",payload)
    },
    count_order_mode({commit}, payload) {
        commit("count_order_mode", payload);
    },
};

const getters = {
    cart: (state) => state.cart,
    stock: (state) => state.stock,
    order: (state) => state.order,
    payment_processor: (state) => state.payment_processor,
    invoice: (state) => state.invoice,
    line_items: (state) => state.line_items,
    cart_type: (state) => state.cart_type,
    scan_mode: (state) => state.scan_mode,
    oe_mode: (state) => state.oe_mode,
    scan_to_paste: (state) => state.scan_to_paste,
    active_company: (state) => state.active_company,
    active_company_low_stock: () => state.active_company_low_stock,
    in_stock_only: (state) => state.in_stock_only,
    scanned_cart: (state) => state.scanned_cart,
    count_order_mode: (state) => state.count_order_mode,
    allStockHistory: (state) => state.stocks,
    fetch_user_branch_stock_history: (state) => state.stocks,
    fetch_by_inventory_and_branch: (state) => state.stocks,
    source_of_truth: (state) => state.source_of_truth,

    get_orders_transactions: (state) => state.orders_transactions,
    get_orders_receiving: (state) => state.orders_receiving,
    get_pos_transaction_by_id: (state) => state.pos_transaction_by_id,
    get_orders_transaction_by_id: (state) => state.orders_transaction_by_id,
    get_searched_orders_transactions: (state) => state.searched_orders_transactions,

    // Stock Reservations getters
    stockReservations: (state) => state.stock_reservations,
    getReservationsByOrder: (state) => (orderId) => {
        return state.stock_reservations.filter(r => r.quote_id === orderId);
    },
    getReservationsByInventory: (state) => (inventoryId, branchId = null) => {
        return state.stock_reservations.filter(r => {
            return r.inventory_id === inventoryId && 
                   (branchId ? r.source_branch_id === branchId : true);
        });
    },
    getActiveReservations: (state) => {
        return state.stock_reservations.filter(r => r.status === 'active');
    },
    getTotalReservedQuantity: (state) => (inventoryId, branchId) => {
        return state.stock_reservations
            .filter(r => r.inventory_id === inventoryId && 
                        r.source_branch_id === branchId && 
                        r.status === 'active')
            .reduce((sum, r) => sum + r.reserved_quantity, 0);
    },
    inventoryWithReservations: (state) => state.inventory_with_reservations,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
